/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesAccountType } from './WebApiModelsEnumerationTypesAccountType';
import {
    WebApiModelsEnumerationTypesAccountTypeFromJSON,
    WebApiModelsEnumerationTypesAccountTypeFromJSONTyped,
    WebApiModelsEnumerationTypesAccountTypeToJSON,
} from './WebApiModelsEnumerationTypesAccountType';
import type { WebApiModelsEnumerationTypesSubscriptionLevel } from './WebApiModelsEnumerationTypesSubscriptionLevel';
import {
    WebApiModelsEnumerationTypesSubscriptionLevelFromJSON,
    WebApiModelsEnumerationTypesSubscriptionLevelFromJSONTyped,
    WebApiModelsEnumerationTypesSubscriptionLevelToJSON,
} from './WebApiModelsEnumerationTypesSubscriptionLevel';

/**
 * 
 * @export
 * @interface WebApiAdminDtoSetSubscriptionDto
 */
export interface WebApiAdminDtoSetSubscriptionDto {
    /**
     * 
     * @type {Date}
     * @memberof WebApiAdminDtoSetSubscriptionDto
     */
    nextSubscriptionRenewalDate?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesSubscriptionLevel}
     * @memberof WebApiAdminDtoSetSubscriptionDto
     */
    subscriptionLevel?: WebApiModelsEnumerationTypesSubscriptionLevel;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetSubscriptionDto
     */
    smsCredits?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesAccountType}
     * @memberof WebApiAdminDtoSetSubscriptionDto
     */
    accountType?: WebApiModelsEnumerationTypesAccountType;
}

/**
 * Check if a given object implements the WebApiAdminDtoSetSubscriptionDto interface.
 */
export function instanceOfWebApiAdminDtoSetSubscriptionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSetSubscriptionDtoFromJSON(json: any): WebApiAdminDtoSetSubscriptionDto {
    return WebApiAdminDtoSetSubscriptionDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSetSubscriptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSetSubscriptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextSubscriptionRenewalDate': !exists(json, 'nextSubscriptionRenewalDate') ? undefined : (json['nextSubscriptionRenewalDate'] === null ? null : new Date(json['nextSubscriptionRenewalDate'])),
        'subscriptionLevel': !exists(json, 'subscriptionLevel') ? undefined : WebApiModelsEnumerationTypesSubscriptionLevelFromJSON(json['subscriptionLevel']),
        'smsCredits': !exists(json, 'smsCredits') ? undefined : json['smsCredits'],
        'accountType': !exists(json, 'accountType') ? undefined : WebApiModelsEnumerationTypesAccountTypeFromJSON(json['accountType']),
    };
}

export function WebApiAdminDtoSetSubscriptionDtoToJSON(value?: WebApiAdminDtoSetSubscriptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextSubscriptionRenewalDate': value.nextSubscriptionRenewalDate === undefined ? undefined : (value.nextSubscriptionRenewalDate === null ? null : value.nextSubscriptionRenewalDate.toISOString()),
        'subscriptionLevel': WebApiModelsEnumerationTypesSubscriptionLevelToJSON(value.subscriptionLevel),
        'smsCredits': value.smsCredits,
        'accountType': WebApiModelsEnumerationTypesAccountTypeToJSON(value.accountType),
    };
}

